import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePage from "./pages/HomePage";
// import HomePageTwo from "./pages/HomePage";
// import HomePageThree from "./pages/HomePageThree";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
import VendorRegistrationPage from "./pages/VendorRegistrationPage";
import BusinessRegistrationPage from "./pages/BusinessRegistrationPage";
import CouponRegistrationPage from "./pages/CouponRegistrationPage";
import FeaturedCouponRegistrationPage from "./pages/FeaturedCouponRegistrationPage";
import CategoryFeaturedCouponRegistrationPage from "./pages/CategoryFeaturedCouponRegistrationPage";
import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
// import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import TutorialPage from "./pages/TutorialPage";
import WishlistPage from "./pages/WishlistPage";
import VendorLoginPage from "./pages/VendorLoginPage";
import UserDashboardPage from "./pages/UserDashboardPage";
import VendorDashboardPage from "./pages/VendorDashboardPage";
import SuccessPage from "./pages/SuccessPage";
import CouponRedemptionPage from "./pages/CouponRedemptionPage";
import CouponReviewPage from "./pages/CouponReviewPage";
import ProtectedUserRoute from "./helper/ProtectedUserRoute";
import ProtectedAdminRoute from "./helper/ProtectedAdminRoute";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";

// Unimportant comment1:

function App() {
  return (
    <AdminAuthProvider>
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Routes>
        <Route exact path='/' element={<HomePage />} />
        {/* <Route exact path='/index-two' element={<HomePage />} />
        <Route exact path='/index-three' element={<HomePageThree />} /> */}
        <Route exact path='/shop' element={<ShopPage />} />
        <Route exact path='/product-details' element={<ProductDetailsPageOne />} />
        <Route exact path='/coupon/:id' element={<ProductDetailsPageTwo />} />
        <Route exact path='/cart' element={<ProtectedUserRoute><CartPage /></ProtectedUserRoute>} />
        <Route exact path='/vendor-registration' element={<VendorRegistrationPage />} />
        <Route exact path='/coupon-registration' element={<CouponRegistrationPage />} />
        <Route exact path='/featured-coupon-registration' element={<FeaturedCouponRegistrationPage />} />
        <Route exact path='/category-featured-coupon-registration' element={<CategoryFeaturedCouponRegistrationPage />} />
        <Route exact path='/business-registration' element={<BusinessRegistrationPage />} />
        <Route exact path='/become-seller' element={<BecomeSellerPage />} />
        <Route exact path='/tutorial' element={<TutorialPage />} />
        {/* <Route exact path='/wishlist' element={<WishlistPage />} /> */}
        <Route exact path='/account-login' element={<AccountPage />} />
        <Route exact path='/user-dashboard' element={<UserDashboardPage />} />
        <Route exact path='/vendor-dashboard' element={<VendorDashboardPage />} />
        <Route exact path='/blog' element={<BlogPage />} />
        {/* <Route exact path='/blog-details' element={<BlogDetailsPage />} /> */}
        <Route exact path='/contact' element={<ContactPage />} />
        <Route exact path='/vendor' element={<VendorPage />} />
        <Route exact path='/vendor/details' element={<VendorDetailsPage />} />
        <Route exact path='/vendor-two' element={<VendorTwoPage />} />
        <Route exact path='/vendor/:id' element={<VendorTwoDetailsPage />} />
        <Route exact path='/vendor-login' element={<VendorLoginPage />} />
        <Route exact path='/success' element={<SuccessPage />} />
        <Route exact path='/coupon/:id/redemption-process' element={<ProtectedUserRoute><CouponRedemptionPage /></ProtectedUserRoute>} />
        <Route exact path='/coupon/:id/review' element={<CouponReviewPage />} />
        <Route exact path='/funcard-admin-dashboard' element={<AdminLoginPage />} />
        <Route exact path='/funcard-admin-dashboard/panel' element={<ProtectedAdminRoute><AdminDashboardPage /></ProtectedAdminRoute>} />
      </Routes>
    </BrowserRouter>
    </AdminAuthProvider>
  );
}

export default App;
